import CustomAnchor from "../../../../shared/Anchor/CustomAnchor";
import "./ProductItem.css";

function ProductItem({ item }) {
  return (
    <div path={item?.link} className="col-md-3 col-10 m-0 product-item">
      <div className="product-item-card">
        <div className="product-cover">
          <img
            src={require(`../../../../assets/images/products/${item?.cover}`)}
            alt={item?.name}
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        <div className="product-details">
          <h4>{item?.name}</h4>
          <p className="d-flex gap-2">
            <span className="product-item-price">{item?.price}</span>
            {item?.size && <span>-</span>}
            {item?.size && <span>{item?.size}</span>}
          </p>
        </div>
        <div className="product-actions">
          <CustomAnchor
            path={item?.link}
            classname="btn btn-dark btn-sm form-control product-shop-button"
          >
            Shop
          </CustomAnchor>
        </div>
      </div>
    </div>
  );
}

export default ProductItem;
